import { APPS, AppType } from 'ui/constants/app.constant';

// eslint-disable-next-line turbo/no-undeclared-env-vars
export const APP_TYPE: AppType = (process?.env?.NEXT_PUBLIC_APP_TYPE ?? APPS.RECRUITER) as AppType;
